import React from 'react';
export const SocialValidation = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6 border-t border-gray-200 pt-10" data-id="element-153" data-mp="13i1xkbni7qzw">
      <h2 className="font-bold text-2xl md:text-3xl mb-6 text-gray-900" data-id="element-154" data-mp="1xdfypprlbv7k">
        Thousands Have Already Made The Switch
      </h2>

      <p data-id="element-155" data-mp="1sf67trcwfgrr">
        Readers everywhere are sharing how{' '}
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-156" data-mp="1sgpovk6dpvul">
          VelaSleep
        </a>{' '}
        has impacted their daily routines.
      </p>

      <div className="space-y-6 my-8 text-base" data-id="element-157" data-mp="1in0eoeawutaz">
        <div className="p-5 rounded-sm border border-gray-200 bg-[#E3E1DB]" data-id="element-158" data-mp="1dp78vmdis1b8">
          <div className="text-yellow-500 font-bold mb-2" data-id="element-159" data-mp="1dn49wcue2xud">★★★★★</div>
          <p className="italic text-gray-700 m-0" data-id="element-160" data-mp="19pgbv0xegoy9">
            "I've bought more pillows than I can count. This is the first one
            I've continued using."
          </p>
          <p className="font-bold text-gray-900 mt-2 mb-0" data-id="element-161" data-mp="zqqrn1i16seu">— Karen, 58</p>
        </div>
        <div className="p-5 rounded-sm border border-gray-200 bg-[#E3E1DB]" data-id="element-162" data-mp="17qhtgtsuf8no">
          <div className="text-yellow-500 font-bold mb-2" data-id="element-163" data-mp="1chq0jj6pahxo">★★★★★</div>
          <p className="italic text-gray-700 m-0" data-id="element-164" data-mp="1cj14pk425rpb">
            "I thought my mattress was the problem. Turns out it was my pillow."
          </p>
          <p className="font-bold text-gray-900 mt-2 mb-0" data-id="element-165" data-mp="13owjphblvahp">— Michael, 63</p>
        </div>
        <div className="p-5 rounded-sm border border-gray-200 bg-[#E3E1DB]" data-id="element-166" data-mp="1rfa20g4e1uz3">
          <div className="text-yellow-500 font-bold mb-2" data-id="element-167" data-mp="1rd5za1i8720e">★★★★★</div>
          <p className="italic text-gray-700 m-0" data-id="element-168" data-mp="1vg2av89clxuu">
            "As a side sleeper, this made a noticeable difference within the
            first week."
          </p>
          <p className="font-bold text-gray-900 mt-2 mb-0" data-id="element-169" data-mp="1mf4gzismj6pz">— Jennifer, 52</p>
        </div>
        <div className="p-5 rounded-sm border border-gray-200 bg-[#E3E1DB]" data-id="element-170" data-mp="614k6gp2rx6y">
          <div className="text-yellow-500 font-bold mb-2" data-id="element-171" data-mp="b0qw8mt637e6">★★★★★</div>
          <p className="italic text-gray-700 m-0" data-id="element-172" data-mp="b220enqiyh5t">
            "After years of chiropractor visits, this became part of my nightly
            routine."
          </p>
          <p className="font-bold text-gray-900 mt-2 mb-0" data-id="element-173" data-mp="3j26rue0papse">— David, 61</p>
        </div>
      </div>
    </section>;
};